module.exports = __webpack_public_path__ + "static/media/img1.20a0fe6d.jpg";